import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import ClientCard from "../ClientCard";

interface ClientProps {}
const Clients: React.FC<ClientProps> = () => {
  return (
    <Flex
      w="100%"
      h="16vh"
      direction="column"
      align="center"
      p={5}
      bg="#f0f0f0"
    >
      <Text fontWeight="extrabold" fontSize="lg" fontFamily="Poppins, sans-serif">
        Among Our Clients
      </Text>
      <Flex w="90%" h="80%" justify="space-between" mt={4} alignSelf="center">
        <ClientCard bgImage="/img/logos/waltons-logo.png" />
        <ClientCard bgImage="/img/logos/bidvest-logo.png" />
        <ClientCard bgImage="/img/logos/nvision-logo.png" />
        <ClientCard bgImage="/img/logos/pureau-logo.png" />
        <ClientCard bgImage="/img/logos/adcock-logo.png" />
        <ClientCard bgImage="/img/logos/ecu-logo.png" />
        <ClientCard bgImage="/img/logos/ewe-logo.png" />
        <ClientCard bgImage="/img/logos/khulisa-logo.png" />
        <ClientCard bgImage="/img/logos/talula-logo.png" />
      </Flex>
    </Flex>
  );
};
export default Clients;
